export default __webpack_public_path__ + "static/classic-white-7fc3cfa41ecdb56d2ea5388ed46387fd.svg";